/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".bg-light-gray[_ngcontent-%COMP%]{background-color:#ededed;border-radius:6px}.passwordCriteria[_ngcontent-%COMP%]{background-color:#90ee90}.add-double-checkboxes[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{margin-top:0;width:102px}@media (max-width:1024px){.showPassword[_ngcontent-%COMP%]{margin-bottom:-25px}.userName[_ngcontent-%COMP%]{margin-bottom:-30px}}@media (min-width:1024px){.eDocPasswordCriteria[_ngcontent-%COMP%]{margin-top:25.2%}}\n/*# sourceMappingURL=password-form.component.css.map*/"];
export { styles as styles };
